var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67441 13.6988C7.65732 13.759 7.64124 13.8101 7.62817 13.8612C6.86924 16.8829 6.7848 17.5541 6.00476 18.9577C5.63283 19.6248 5.21366 20.2571 4.75025 20.8619C4.69798 20.9303 4.64872 21.0182 4.54418 20.9967C4.42959 20.9722 4.42054 20.867 4.40848 20.774C4.28383 19.8556 4.21447 18.9352 4.24463 18.0077C4.28383 16.8002 4.4306 16.3854 5.96254 9.83935C5.98465 9.73924 5.95952 9.65649 5.92735 9.56659C5.56045 8.56139 5.48808 7.54086 5.80874 6.50705C6.50233 4.27394 8.99325 4.10335 9.4285 5.9452C9.69689 7.08423 8.98722 8.57569 8.44239 10.7802C7.99105 12.5985 10.098 13.8918 11.8983 12.5638C13.5589 11.34 14.2033 8.40611 14.0806 6.32624C13.8394 2.17977 9.36518 1.28387 6.52747 2.61903C3.2736 4.14829 2.53377 8.24675 4.00338 10.1203C4.18935 10.3583 4.54016 10.5044 4.47885 10.7455C4.38436 11.1204 4.30092 11.4983 4.19839 11.8712C4.12199 12.1491 3.68674 12.2502 3.41031 12.1358C2.8685 11.9131 2.41716 11.5627 2.05126 11.101C0.803793 9.53084 0.446944 6.42533 2.0965 3.79586C3.92397 0.883421 7.32359 -0.295446 10.4277 0.0620964C14.1349 0.490126 16.478 3.06443 16.9163 5.98504C17.1164 7.3151 16.9726 10.5953 15.1351 12.9142C13.0211 15.5784 9.59436 15.7551 8.01316 14.1196C7.89153 13.994 7.79403 13.8479 7.67441 13.6977V13.6988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.9d31e950ee5807d3cf8fa66feeef9ded.svg";
export { ForwardRef as ReactComponent };